import { useEffect } from 'react'
import { LEGAL_CONTACT_EMAIL } from './legalPages.js'

export default function LegalPage({ page }) {
  useEffect(() => {
    const previousTitle = document.title
    document.title = `${page.title} - kickr`
    return () => { document.title = previousTitle }
  }, [page.title])

  return (
    <main style={{ maxWidth: 760, margin: '0 auto', padding: '48px 20px 72px', lineHeight: 1.6, color: '#0d1526', fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>
      <div style={{ color: '#22c55e', fontWeight: 900, marginBottom: 28 }}>kickr</div>
      <h1 style={{ fontSize: 'clamp(32px, 8vw, 52px)', lineHeight: 1, margin: '0 0 12px', letterSpacing: 0 }}>{page.title}</h1>
      <p style={{ color: '#5f7166', marginBottom: 28 }}>{page.updated}</p>
      <p>{page.intro}</p>
      {page.sections.map(([heading, body]) => (
        <section key={heading}>
          <h2 style={{ marginTop: 34, fontSize: 20 }}>{heading}</h2>
          <p>{body}</p>
        </section>
      ))}
      <section>
        <h2 style={{ marginTop: 34, fontSize: 20 }}>Contact</h2>
        <p>{page.contactLabel} <a href={`mailto:${LEGAL_CONTACT_EMAIL}`} style={{ color: '#16a34a', fontWeight: 700 }}>{LEGAL_CONTACT_EMAIL}</a>.</p>
      </section>
    </main>
  )
}
